<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPicker: false,
      show: false,
    };
  },
  created() {
    // this.GlobalConfig();
  },

  methods: {
    GlobalConfig: async function () {
      // 续费到期时间
      if (sessionStorage.getItem("ad_member_token")) {
        const res = await this.http.get("/user/info", {}, false);
        if (res.data.status === 200) {
          console.log(res.data);
        } else {
          this.$router.push("/Login");
        }
      } else {
        this.$router.push("/Login");
      }
    },
  },
};
</script>

<style lang="less">
@import "./assets/css/reset.less";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.environment {
  position: fixed;
  bottom: 30px;
  right: 30px;
  font-size: 14px;
  color: #fff;
  padding: 5px 10px;
  background-color: red;
  color: #fff;
  border-radius: 5px;
  z-index: 100;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
